import * as types from '../types';
import { IUsersApi } from '../contracts';
import { HttpApi } from './HttpApi';

export class UsersHttpApi extends HttpApi implements IUsersApi {
  async listUsers(includeInactive = false): Promise<types.UserListItem[]> {
    // Backend returns every matching user for the tenant in one unpaginated array.
    const response = await this.http.get<types.APIResponse<types.UserListItem[]>>('/users', {
      params: includeInactive ? { includeInactive: 'true' } : undefined,
    });
    return response.data.data;
  }

  async listAssignableUsers(): Promise<types.AssignableUser[]> {
    const response = await this.http.get<types.APIResponse<types.AssignableUser[]>>('/users/assignable');
    return response.data.data;
  }

  async getUser(id: string): Promise<types.UserDetail> {
    const response = await this.http.get<types.APIResponse<types.UserDetail>>(`/users/${id}`);
    return response.data.data;
  }

  async createUser(data: types.CreateUserRequest): Promise<types.UserDetail> {
    const response = await this.http.post<types.APIResponse<types.UserDetail>>('/users', data);
    return response.data.data;
  }

  async updateUser(id: string, data: types.UpdateUserRequest): Promise<types.UserDetail> {
    const response = await this.http.patch<types.APIResponse<types.UserDetail>>(`/users/${id}`, data);
    return response.data.data;
  }

  async deactivateUser(id: string): Promise<void> {
    await this.http.delete(`/users/${id}`);
  }

  async resetUserPassword(id: string, newPassword: string): Promise<void> {
    const body: types.ResetUserPasswordRequest = { newPassword };
    await this.http.post(`/users/${id}/reset-password`, body);
  }

  async changeOwnPassword(currentPassword: string, newPassword: string): Promise<void> {
    const body: types.ChangeOwnPasswordRequest = { currentPassword, newPassword };
    await this.http.patch('/users/me/password', body);
  }
}
